import React from "react"
import { useTranslation } from "react-i18next"
import PoweredByAeraImage from "../../../images/icons/powered-by-aera.png"
import "./FormFooter.scss"
import cn from "classnames"
interface IFormFooterProps {
    className?: string
}

const FormFooter = ({ className }: IFormFooterProps) => {
    const { t } = useTranslation()
    return (
        <div className={cn("swiipe-form-footer form-footer mb-2 mt-5", className)}>
            <p className="text-center">
                <img src={PoweredByAeraImage} className="logo" />
            </p>
        </div>
    )
}

export default FormFooter
